'use client';

import { __extends } from '../../_virtual/_tslib.js';
import Base from './base.js';
import { errorMsgs } from './constants.js';

var StringValidator = /** @class */ (function (_super) {
    __extends(StringValidator, _super);
    function StringValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringValidator.prototype.email = function (msg) {
        this.rules.push({
            type: 'email',
            msg: msg || errorMsgs(this.translate).email
        });
        return this;
    };
    StringValidator.prototype.url = function (msg) {
        this.rules.push({
            type: 'url',
            msg: msg || errorMsgs(this.translate).url
        });
        return this;
    };
    StringValidator.prototype.noNumberAndEmail = function (msg) {
        this.rules.push({
            type: 'no-number-email',
            msg: msg || errorMsgs(this.translate)['no-number-email']
        });
        return this;
    };
    StringValidator.prototype.noSpecialChars = function (msg) {
        this.rules.push({
            type: 'no-special-chars',
            msg: msg || errorMsgs(this.translate)['no-special-chars']
        });
        return this;
    };
    StringValidator.prototype.noSpecialCharsWithoutNumber = function (msg) {
        this.rules.push({
            type: 'no-special-chars-without-number',
            msg: msg || errorMsgs(this.translate)['no-special-chars-without-number']
        });
        return this;
    };
    StringValidator.prototype.vnPhoneNumber = function (msg) {
        this.rules.push({
            type: 'vn-phone-number',
            msg: msg || errorMsgs(this.translate)['vn-phone-number']
        });
        return this;
    };
    StringValidator.prototype.internationalPhoneNumber = function (msg) {
        this.rules.push({
            type: 'international-phone-number',
            msg: msg || errorMsgs(this.translate)['international-phone-number']
        });
        return this;
    };
    StringValidator.prototype.noSpecialCharsForJobTitle = function (msg) {
        this.rules.push({
            type: 'no-special-chars-for-job-title',
            msg: msg || errorMsgs(this.translate)['no-special-chars-for-job-title']
        });
        return this;
    };
    StringValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length > limit;
                }
                return false;
            }
        });
        return this;
    };
    StringValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length < limit;
                }
                return false;
            }
        });
        return this;
    };
    StringValidator.prototype.length = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (typeof value === 'string') {
                    return value.length <= limit;
                }
                return false;
            }
        });
        return this;
    };
    return StringValidator;
}(Base));

export { StringValidator as default };
//# sourceMappingURL=string.js.map
